// made accessible through NtDnDContext objects under DnD callbacks (see NtDnDContext for further details)
export enum NtDndActionType {
    DUPLICATE_SAME_HANDLER,
    DUPLICATE_ACROSS_HANDLERS,
    MOVE_ACROSS_HANDLERS,
    REORDER_SAME_HANDLER
}
